import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

interface FleetUIState {
  selectedDroneId: string | null;
}

const initialState: FleetUIState = {
  selectedDroneId: null,
};

export const fleetSlice = createSlice({
  name: "fleetUI",
  initialState,
  reducers: {
    selectDrone: (state, action: PayloadAction<string | null>) => {
      state.selectedDroneId = action.payload;
    },
  },
});

export const { selectDrone } = fleetSlice.actions;
export default fleetSlice.reducer;
